module.exports = __webpack_public_path__ + "static/media/enhanced_armor.76ac13ea.png";